module.exports = __webpack_public_path__ + "static/img/13.4a9a0c7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/word/13.png
// module id = OP5c
// module chunks = 1